/*! assets/av-release-feed.js — AutoVectors release archive renderer (virtual release schedule).
 *
 *  Loaded ONLY by sections/latest-products-blog.liquid (the page
 *  /blogs/knowledge-hub/new-ppf-templates-latest-autovectors-patterns), synchronously, after the
 *  page's containers and before the section's legacy script, which waits for
 *  window.avReleaseFeed.onReady(...) instead of DOMContentLoaded.
 *
 *  What it does
 *    1. fetches /collections/latest-templates?view=av-feed (page 1 first, then every other page
 *       in the background, 6 at a time) through window.avFeed (snippets/av-today-counter.liquid,
 *       which also carries window.AvRelease — the algorithm, verbatim from
 *       release-feed/design/release-schedule.mjs);
 *    2. computes every product's VIRTUAL release day with that algorithm (v2 "drip", stateless:
 *       real day in shop time; the real day's window of 20-30 days by hash; the product's day
 *       inside that window by its own hash; hash order inside a day; epoch; mode) — products
 *       whose virtual day is after the shop's today are not rendered at all;
 *    3. renders EXACTLY the markup the Liquid loop used to render (same classes and structure:
 *       .latest-date-group / .latest-product-row / .upload-timeline links / .latest-date-nav links /
 *       .latest-featured-card), with the virtual day in data-upload-date and
 *       "Added today / yesterday / <date>" from virtual dates. No real created_at reaches the DOM;
 *    4. a virtual day is rendered only when no unloaded upload can still land on it ("final":
 *       the loaded pages reach the longest window back, or the epoch); whole days are rendered
 *       newest first, about 96 rows at a time, the rest waits for "Load more";
 *    5. sets data-today-count (today's virtual count) on the creator panel, publishes it through
 *       window.avFeed.publish (window.avTodayCount + "av:today-count") and caches it for the
 *       site-wide bar, then hands over to the legacy script (timeline decorations, streaks,
 *       achievements, intro) via onReady once all pages are loaded.
 *
 *  Exposed for the node proof (release-feed/proof/verify-release-feed.mjs):
 *    window.avReleaseFeed.compute({ today })  -> per virtual day: count, sources, digest (never titles)
 *    window.avReleaseFeed.domDigest()          -> what is actually in the DOM, per day
 */
(function () {
  'use strict';

  var R = window.AvRelease;
  var F = window.avFeed;
  var CONCURRENCY = 6;
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var TODAY_LABEL = 'Today’s Template Drop';

  var readyCbs = [];
  var isReady = false;

  var pages = [];          // pages[n-1] = feed page n (contiguous prefix is what gets scheduled)
  var loadingPage = {};
  var pagesTotal = 0;
  var today = '';
  var settings = null;
  var renderedThrough = 0; // feed pages loaded when the last chunk was rendered (state only)
  var INITIAL_ROWS = 96;   // whole virtual days are rendered until this many rows are on the page
  var MORE_ROWS = 96;      // "Load more releases" adds whole days until this many more rows
  var loadingAll = null;   // the promise of loadRest()
  var rendered = {};       // virtual day -> true
  var renderedCount = 0;
  var todayCountValue = null;
  var full = null;         // schedule over every loaded page once loading finished
  var featuredDone = false;
  var loadMoreBusy = null;
  var loadErrors = [];

  var api = {
    version: 1,
    ready: false,
    error: null,
    onReady: onReady,
    dailyCounts: dailyCounts,
    compute: compute,
    domDigest: domDigest,
    loadMore: loadMore,
    ensureDay: ensureDay,
    state: state
  };
  window.avReleaseFeed = api;

  // ---------- DOM refs (the section's containers precede this script) ----------
  function $(sel, root) { return (root || document).querySelector(sel); }
  var list = $('.latest-products-list');
  var statusEl = list ? $('[data-role="release-feed-status"]', list) : null;
  var timeline = $('.upload-timeline');
  var dateNav = $('.latest-date-nav');
  var featuredGrid = $('.latest-featured-strip-grid');
  var loadMoreNav = $('[data-role="release-load-more"]');
  var loadMoreBtn = $('[data-role="release-load-more-btn"]');
  var loadMoreStatus = $('[data-role="release-load-more-status"]');

  // ---------- ready handshake with the legacy script ----------
  function whenDom(cb) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { cb(); });
    else cb();
  }
  function onReady(cb) {
    if (isReady) whenDom(cb);
    else readyCbs.push(cb);
  }
  function fireReady() {
    if (isReady) return;
    isReady = true;
    api.ready = true;
    var cbs = readyCbs.splice(0);
    whenDom(function () {
      for (var i = 0; i < cbs.length; i++) {
        try { cbs[i](); } catch (e) { if (window.console) console.error('av-release-feed: legacy init failed', e); }
      }
      // the legacy init defined window.avRenderCreatorPanel synchronously: render the panel from
      // data-today-count now and only then make it visible (no idle-state flash)
      var panel = $('[data-role="creator-panel"]');
      if (typeof window.avRenderCreatorPanel === 'function') { try { window.avRenderCreatorPanel(); } catch (e) {} }
      if (panel) panel.removeAttribute('data-av-pending');
      try { document.dispatchEvent(new CustomEvent('av:release-ready', { detail: state() })); } catch (e) {}
    });
  }

  // ---------- helpers ----------
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return c === '&' ? '&amp;' : c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '"' ? '&quot;' : '&#39;';
    });
  }
  function fragment(html) {
    var t = document.createElement('template');
    t.innerHTML = html;
    return t.content;
  }
  function ymd(day) { var p = day.split('-'); return { y: p[0], m: parseInt(p[1], 10), d: p[2] }; }
  function longLabel(day) { var x = ymd(day); return MONTHS[x.m - 1] + ' ' + x.d + ', ' + x.y; }        // "September 04, 2026"  (Liquid %B %d, %Y)
  function shortLabelYear(day) { var x = ymd(day); return MONTHS_SHORT[x.m - 1] + ' ' + x.d + ', ' + x.y; } // "Sep 04, 2026"        (Liquid %b %d, %Y)
  function shortLabel(day) { var x = ymd(day); return MONTHS_SHORT[x.m - 1] + ' ' + x.d; }               // "Sep 04"              (Liquid %b %d)
  function monthLabel(day) { var x = ymd(day); return MONTHS[x.m - 1] + ' ' + x.y; }                     // "September 2026"      (Liquid %B %Y)
  // The CDN's ?v=<unix seconds> cache-buster is the image's upload time, i.e. the product's real
  // created_at to within seconds — the one thing this page exists to hide. Strip it from every
  // image URL the page renders; the CDN serves the same bytes without it.
  function cleanImg(img) {
    if (!img) return '';
    var s = String(img).replace(/([?&])v=\d+(?=&|$)/, '$1').replace(/[?&]$/, '').replace(/\?&/, '?');
    return s;
  }
  function thumbUrl(img) { return img ? cleanImg(img).replace(/([?&])width=420(?=&|$)/, '$1width=220') : ''; }

  function setStatus(kind, msg) {
    if (!statusEl) return;
    if (kind === 'ok') { statusEl.hidden = true; statusEl.textContent = ''; return; }
    statusEl.hidden = false;
    if (kind === 'loading') {
      statusEl.textContent = 'Loading the latest releases…';
    } else {
      statusEl.innerHTML = 'The release feed could not be loaded' + (msg ? ' (' + esc(msg) + ')' : '') +
        ' — <a href="/collections/latest-templates">browse the latest templates in the collection</a>.';
    }
  }

  // ---------- markup (byte-for-byte the classes/structure of the former Liquid loop) ----------
  function groupHtml(day, todayDay) {
    var label = day === todayDay ? TODAY_LABEL : longLabel(day);
    return '<div class="latest-date-group" id="date-' + day + '" data-date="' + day + '" data-base-label="' + esc(label) + '" data-initial-label="' + esc(label) + '">' +
      '<div class="latest-date-divider">' +
        '<span class="latest-date-divider-line"></span> ' +
        '<a href="#date-' + day + '" class="latest-date-divider-label" data-role="date-label" aria-label="' + esc(label) + '">' +
          '<span class="latest-date-pill-media" data-role="date-pill-media"></span> ' +
          '<span class="latest-date-pill-text-clip" data-role="date-pill-text-clip">' +
            '<span class="latest-date-pill-text-track" data-role="date-pill-text-track">' +
              '<span class="latest-date-pill-text">' + esc(label) + '</span> ' +
              '<span class="latest-date-pill-hover-text" data-role="date-pill-hover-text"></span>' +
            '</span>' +
          '</span>' +
        '</a> ' +
        '<span class="latest-date-divider-line"></span>' +
      '</div>' +
    '</div>';
  }

  function rowHtml(e, todayDay, yesterday) {
    var it = e.product.item;
    var day = e.virtualDay;
    var isToday = day === todayDay;
    var dateText = isToday ? 'Added today' : day === yesterday ? 'Added yesterday' : 'Added ' + day;
    var thumb = thumbUrl(it.img);
    var price = '';
    if (it.p > 0) {
      if (it.cp > it.p) {
        var pct = Math.floor(((it.cp - it.p) * 100) / it.cp);
        price = ' <span class="latest-product-dot">•</span> ' +
          '<span class="latest-product-price-wrap">' +
            '<span class="latest-product-price-compare">' + esc(it.cpm) + '</span> ' +
            '<span class="latest-product-price">' + esc(it.pm) + '</span> ' +
            '<span class="latest-product-discount-badge">-' + pct + '% OFF</span>' +
          '</span>';
      } else {
        price = ' <span class="latest-product-dot">•</span> ' +
          '<span class="latest-product-price-wrap">' +
            '<span class="latest-product-price">' + esc(it.pm) + '</span>' +
          '</span>';
      }
    }
    return '<article class="latest-product-row' + (isToday ? ' is-today-row' : '') + '" data-upload-date="' + day + '">' +
      '<div class="latest-product-reward-bg" data-role="product-reward-bg"></div> ' +
      '<a href="' + esc(it.u) + '" class="latest-product-thumb-link" aria-label="' + esc(it.t) + '">' +
        (thumb ? '<img src="' + esc(thumb) + '" alt="' + esc(it.t) + '" loading="lazy" width="110" height="110" class="latest-product-thumb">' : '') +
      '</a> ' +
      '<div class="latest-product-info">' +
        '<h3 class="latest-product-name"><a href="' + esc(it.u) + '">' + esc(it.t) + '</a></h3> ' +
        '<div class="latest-product-meta-row">' +
          '<span class="latest-product-date">' + dateText + '</span>' + price +
        '</div>' +
      '</div> ' +
      '<div class="latest-product-action"><a href="' + esc(it.u) + '" class="latest-product-view-btn">View</a></div>' +
    '</article>';
  }

  function featuredHtml(e) {
    var it = e.product.item;
    return '<a href="' + esc(it.u) + '" class="latest-featured-card">' +
      (it.img ? '<img src="' + esc(cleanImg(it.img)) + '" alt="' + esc(it.t) + '" loading="lazy" width="210" height="210" class="latest-featured-card-image">' : '') +
      '<div class="latest-featured-card-body">' +
        '<div class="latest-featured-card-title">' + esc(it.t) + '</div> ' +
        '<div class="latest-featured-card-date">Added ' + e.virtualDay + '</div>' +
      '</div>' +
    '</a>';
  }

  function timelineHtml(days, todayDay) {
    var html = '', lastMonth = '';
    for (var i = 0; i < days.length; i++) {
      var d = days[i], month = d.slice(0, 7);
      if (month !== lastMonth) { html += '<div class="timeline-month-separator">' + monthLabel(d) + '</div> '; lastMonth = month; }
      html += '<a href="#date-' + d + '" class="timeline-date" data-date="' + d + '" data-page="1" data-base-label="' + shortLabelYear(d) + '">' +
        '<span class="latest-date-pill-media" data-role="timeline-pill-media"></span> ' +  // the class the CSS sizes (the legacy script builds its pills with it too); "timeline-date-pill-media" has no rules, so medal images rendered at natural size and pushed the date out
        '<span class="timeline-date-label">' + (d === todayDay ? 'Today' : shortLabelYear(d)) + '</span>' +
      '</a> ';
    }
    return html;
  }

  function dateNavHtml(days, todayDay) {
    var html = '', lastMonth = '';
    for (var i = 0; i < days.length; i++) {
      var d = days[i], month = d.slice(0, 7);
      if (month !== lastMonth) { html += '<span class="latest-date-month-separator">' + monthLabel(d) + '</span> '; lastMonth = month; }
      html += '<a href="#date-' + d + '" class="latest-date-nav-link" data-date="' + d + '">' +
        '<span class="latest-date-pill-media" data-role="topnav-pill-media"></span> ' +
        '<span class="latest-date-nav-link-text">' + (d === todayDay ? 'Today' : shortLabel(d)) + '</span>' +
      '</a> ';
    }
    return html;
  }

  // ---------- feed loading ----------
  function loadPage(n) {
    if (pages[n - 1]) return Promise.resolve(pages[n - 1]);
    if (loadingPage[n]) return loadingPage[n];
    var attempt = function () { return F.fetchPage(n); };
    var p = attempt().then(null, attempt).then(function (data) {
      pages[n - 1] = data;
      delete loadingPage[n];
      return data;
    }, function (err) {
      delete loadingPage[n];
      loadErrors.push('page ' + n + ': ' + (err && err.message ? err.message : err));
      throw err;
    });
    loadingPage[n] = p;
    return p;
  }
  function loadedPrefix() { var k = 0; while (pages[k]) k++; return k; }
  function loadPagesThrough(k) {
    var tasks = [];
    for (var n = 1; n <= k; n++) tasks.push(loadPage(n));
    return Promise.all(tasks);
  }
  // pages 2..pagesTotal, CONCURRENCY at a time; a failed page stops the contiguous prefix there
  function loadRest() {
    var next = 2;
    function worker() {
      if (next > pagesTotal) return Promise.resolve();
      var n = next++;
      return loadPage(n).then(null, function () {}).then(worker);
    }
    var workers = [];
    for (var i = 0; i < CONCURRENCY; i++) workers.push(worker());
    return Promise.all(workers);
  }

  // ---------- scheduling ----------
  function scheduleFor(k) { return F.scheduleLoaded(pages.slice(0, k)); }
  function finalDays(sched) {
    return R.renderDays(sched.entries, sched.today).filter(function (d) { return F.isFinalDay(sched, d.day); });
  }
  function visibleDays(sched) {
    var seen = {}, days = [];
    for (var i = 0; i < sched.entries.length; i++) {
      var e = sched.entries[i];
      if (e.virtualDay > sched.today || seen[e.virtualDay]) continue;
      seen[e.virtualDay] = true;
      days.push(e.virtualDay);
    }
    days.sort().reverse();
    return days;
  }

  // ---------- rendering ----------
  // Renders the newest not-yet-rendered FINAL virtual days, whole days, until `budget` rows were
  // added (newest first, so later chunks append older days). With every feed page loaded every day
  // is final; when pages are missing (a page failed) `force` renders what is there rather than nothing.
  function renderMore(budget, force) {
    var sched = full ? full.sched : scheduleFor(loadedPrefix());
    if (!sched) return 0;
    var days = force ? R.renderDays(sched.entries, sched.today) : finalDays(sched);
    var yesterday = R.addDays(sched.today, -1);
    var html = '', added = 0;
    for (var i = 0; i < days.length; i++) {
      var d = days[i];
      if (rendered[d.day]) continue;
      if (added >= budget) break;
      rendered[d.day] = true;
      html += groupHtml(d.day, sched.today);
      for (var j = 0; j < d.items.length; j++) { html += rowHtml(d.items[j], sched.today, yesterday); added++; }
    }
    if (html && list) {
      list.insertBefore(fragment(html), statusEl || null);
      renderedCount += added;
    }
    renderedThrough = loadedPrefix();
    if (!featuredDone && days.length && featuredGrid) {
      featuredGrid.innerHTML = days[0].items.slice(0, 4).map(featuredHtml).join(' ');
      featuredDone = true;
    }
    if (!isReady) renderNav(sched);
    updateLoadMore();
    try { document.dispatchEvent(new CustomEvent('av:release-rendered', { detail: { pages: loadedPrefix(), added: added } })); } catch (e) {}
    return added;
  }
  // visible virtual days not yet in the DOM (-1 while pages are still loading)
  function unrenderedDays() {
    if (!full) return -1;
    var days = R.renderDays(full.sched.entries, full.sched.today), n = 0;
    for (var i = 0; i < days.length; i++) if (!rendered[days[i].day]) n++;
    return n;
  }

  // the timeline and the bottom date navigation list every visible virtual day of the loaded pages;
  // rebuilt while pages are still arriving, final once every page is in (before the legacy script decorates them)
  function renderNav(sched) {
    var days = visibleDays(sched);
    if (timeline) timeline.innerHTML = timelineHtml(days, sched.today);
    if (dateNav) {
      var label = dateNav.querySelector('.latest-date-nav-label');
      dateNav.innerHTML = '';
      if (label) { dateNav.appendChild(label); dateNav.appendChild(document.createTextNode(' ')); }
      dateNav.insertAdjacentHTML('beforeend', dateNavHtml(days, sched.today));
    }
  }

  function setPanelCount(count, todayDay) {
    var panel = $('[data-role="creator-panel"]');
    if (list) {
      list.setAttribute('data-today', todayDay);
      list.setAttribute('data-active-drop-date', todayDay);
    }
    if (!panel) return;
    panel.setAttribute('data-today-count', String(count));
    panel.setAttribute('data-today', todayDay);
    panel.removeAttribute('data-today-capped');
    if (typeof window.avRenderCreatorPanel === 'function') {
      try { window.avRenderCreatorPanel(); } catch (e) {}
      panel.removeAttribute('data-av-pending');
    }
  }

  // today's virtual count from k pages; false while more pages are needed (unless force)
  function publishToday(k, force) {
    var sched = scheduleFor(k);
    var isFinal = F.isFinalDay(sched, sched.today);
    if (!isFinal && !force) return false;
    var count = R.todayCount(sched.entries, sched.today);
    todayCountValue = count;
    setPanelCount(count, sched.today);
    var data = {
      today: sched.today,
      count: count,
      mode: sched.settings.mode,
      daysMin: sched.settings.daysMin,
      daysMax: sched.settings.daysMax,
      epoch: sched.settings.epoch,
      generated: pages[0].now,
      pages: k,
      partial: !isFinal
    };
    F.writeCache(data);
    F.publish(data);
    return true;
  }

  function updateLoadMore() {
    if (!loadMoreNav) return;
    var done = unrenderedDays() === 0;
    if (done) { loadMoreNav.hidden = true; return; }
    loadMoreNav.hidden = false;
    if (loadMoreStatus) {
      loadMoreStatus.textContent = full
        ? 'Showing ' + renderedCount + ' of ' + full.visibleCount + ' released templates'
        : 'Showing ' + renderedCount + ' released templates';
    }
  }
  function setLoadMoreState(s) {
    if (!loadMoreBtn) return;
    loadMoreBtn.textContent = s === 'loading' ? 'Loading…' : s === 'error' ? 'Retry loading' : 'Load more releases';
    loadMoreBtn.classList.toggle('is-loading', s === 'loading');
  }

  function loadMore() {
    if (loadMoreBusy) return loadMoreBusy;
    if (unrenderedDays() === 0) { updateLoadMore(); return Promise.resolve(0); }
    setLoadMoreState('loading');
    loadMoreBusy = (loadingAll || Promise.resolve()).then(null, function () {}).then(function () {
      var added = renderMore(MORE_ROWS, !!(full && full.incomplete));
      if (isReady && typeof window.avReleaseDecorate === 'function') { try { window.avReleaseDecorate(); } catch (e) {} }
      loadMoreBusy = null;
      setLoadMoreState('idle');
      return added;
    }, function (err) {
      loadMoreBusy = null;
      setLoadMoreState('error');
      throw err;
    });
    return loadMoreBusy;
  }

  // render chunks until the virtual day is in the DOM (used by timeline / date-nav clicks)
  function ensureDay(day) {
    if (rendered[day]) return Promise.resolve(true);
    if (unrenderedDays() === 0) return Promise.resolve(false);
    return loadMore().then(function (added) { return added ? ensureDay(day) : false; }, function () { return false; });
  }

  // ---------- data for the legacy script and the proof ----------
  function currentSchedule() {
    if (full) return full.sched;
    var k = loadedPrefix();
    return k ? scheduleFor(k) : null;
  }
  // virtual day -> count, visible days only (what the legacy streak / achievement / tier logic consumes)
  function dailyCounts() {
    var sched = currentSchedule();
    var counts = {};
    if (!sched) return counts;
    for (var i = 0; i < sched.entries.length; i++) {
      var e = sched.entries[i];
      if (e.virtualDay > sched.today) continue;
      counts[e.virtualDay] = (counts[e.virtualDay] || 0) + 1;
    }
    return counts;
  }
  // { today, days: [{ day, count, from: {realDay: n}, hidden, digest }] } — digest = FNV-1a of the ids in display order
  function compute(opts) {
    opts = opts || {};
    var sched = currentSchedule();
    if (!sched) return null;
    var T = opts.today || sched.today;
    var s = sched.settings;
    var entries = R.schedule(sched.split.complete, { today: T, daysMin: s.daysMin, daysMax: s.daysMax, epoch: s.epoch, mode: s.mode });
    var byDay = {}, order = [];
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      var d = byDay[e.virtualDay];
      if (!d) { d = byDay[e.virtualDay] = { day: e.virtualDay, count: 0, from: {}, ids: [], hidden: e.virtualDay > T }; order.push(d); }
      d.count++;
      d.from[e.realDay] = (d.from[e.realDay] || 0) + 1;
      d.ids.push(e.id);
    }
    for (var j = 0; j < order.length; j++) { order[j].digest = R.fnv1a32(order[j].ids.join(',')); delete order[j].ids; }
    return {
      today: T, feedToday: sched.today, settings: s, pagesLoaded: loadedPrefix(), complete: !sched.hasNext,
      pendingDay: sched.split.pendingDay, todayCount: R.todayCount(entries, T), days: order
    };
  }
  // what the DOM shows: per data-upload-date group, count + FNV-1a of the product URLs in DOM order
  function domDigest() {
    if (!list) return null;
    var rows = list.querySelectorAll('.latest-product-row');
    var days = [], cur = null, urls = [];
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      var d = r.getAttribute('data-upload-date');
      var a = r.querySelector('.latest-product-name a');
      var u = a ? a.getAttribute('href') : '';
      if (!cur || cur.day !== d) { cur = { day: d, count: 0, urls: [] }; days.push(cur); }
      cur.count++;
      cur.urls.push(u);
      urls.push(u);
    }
    for (var j = 0; j < days.length; j++) { days[j].digest = R.fnv1a32(days[j].urls.join(',')); delete days[j].urls; }
    var groups = [];
    var g = list.querySelectorAll('.latest-date-group');
    for (var k = 0; k < g.length; k++) {
      var t = g[k].querySelector('.latest-date-pill-text');
      groups.push({ day: g[k].getAttribute('data-date'), label: t ? t.textContent : '' });
    }
    var tl = timeline ? timeline.querySelectorAll('.timeline-date') : [];
    var tlDays = [];
    for (var m = 0; m < tl.length; m++) tlDays.push(tl[m].getAttribute('data-date'));
    var featured = [];
    var fc = featuredGrid ? featuredGrid.querySelectorAll('.latest-featured-card') : [];
    for (var q = 0; q < fc.length; q++) featured.push(fc[q].getAttribute('href'));
    var panel = $('[data-role="creator-panel"]');
    return {
      rows: urls.length, days: days, groups: groups, timelineDays: tlDays, featured: featured,
      todayRows: list.querySelectorAll('.latest-product-row.is-today-row').length,
      panelTodayCount: panel ? panel.getAttribute('data-today-count') : null,
      listToday: list.getAttribute('data-today')
    };
  }
  function state() {
    return {
      pagesLoaded: loadedPrefix(), pagesTotal: pagesTotal, renderedThrough: renderedThrough,
      renderedDays: Object.keys(rendered).length, renderedProducts: renderedCount, today: today,
      todayCount: todayCountValue, settings: settings, ready: isReady, error: api.error, loadErrors: loadErrors.slice()
    };
  }

  // ---------- events ----------
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      loadMore().then(null, function () {});
    });
  }
  // a timeline / date-nav click on a day that is not rendered yet: render up to it, then let the
  // legacy handlers (which need the target element) run by re-clicking the link
  document.addEventListener('click', function (e) {
    var t = e.target;
    var link = t && t.closest ? t.closest('.timeline-date, .latest-date-nav-link') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var i = href.indexOf('#date-');
    if (i < 0) return;
    var id = href.slice(i + 1);
    if (document.getElementById(id)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ensureDay(id.replace(/^date-/, '')).then(function () {
      if (document.getElementById(id)) link.click();
    });
  }, true);

  // ---------- main ----------
  function failStart(err) {
    api.error = String(err && err.message ? err.message : err);
    if (window.console) console.error('av-release-feed:', err);
    setStatus('error', api.error);
    if (loadMoreNav) loadMoreNav.hidden = true;
    fireReady();
  }

  function start() {
    if (!list) return; // not the archive page
    if (!R || !F) { failStart(new Error('release schedule script missing (snippets/av-today-counter.liquid)')); return; }
    setStatus('loading');
    loadPage(1).then(function (p1) {
      pagesTotal = Math.max(1, p1.pages | 0);
      today = p1.today;
      settings = F.settingsOf(p1);
      // whatever is already final after page 1 (in the first month after the epoch: everything
      // loaded) is painted at once; otherwise the page paints once every page is in
      renderMore(INITIAL_ROWS, false);
      setStatus('ok');
      var published = publishToday(1, false);
      loadingAll = loadRest();
      return loadingAll.then(function () {
        var k = loadedPrefix();
        var sched = scheduleFor(k);
        var visibleCount = 0;
        for (var i = 0; i < sched.entries.length; i++) if (sched.entries[i].virtualDay <= sched.today) visibleCount++;
        full = { sched: sched, visibleCount: visibleCount, pages: k, incomplete: k < pagesTotal };
        if (renderedCount < INITIAL_ROWS) renderMore(INITIAL_ROWS - renderedCount, full.incomplete);
        if (!published) publishToday(k, true);
        renderNav(sched);
        updateLoadMore();
        if (loadErrors.length) api.error = loadErrors.join('; ');
        fireReady();
      });
    }).catch(failStart);
  }

  start();
})();
